<template>
  <div className="grid-view">
    <div className="main-content">
      <div className="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div className="pagination-wrapper">
        <cargo-pagination
          :config-module="configModule"
          :total="rowData.length"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          layout="total, slot"
          @pagination="toQuery()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'

export default {
  name: 'BillOverseasSSubmitGrid',
  components: {},
  props: {
    configModule: { type: String, default: '410015200' },
    gridOptions: { type: Object, default: () => {} },
    filter: { type: Object, default: () => {} },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      gridParams: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', colId: 'billingNo', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_CounterpartySBillingNo'),
          colId: 'counterPartyBillingNo',
          field: 'counterPartyBillingNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'), colId: 'jobNo', field: 'jobNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'jobOp', field: 'jobOp',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BillDate'), field: 'inputDate', colId: 'inputDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'MBL', field: 'jobMbl', colId: 'jobMbl', width: 200 },
        {
          headerName: 'ETD', field: 'jobEtd', colId: 'jobEtd', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'ETA', field: 'jobEta', colId: 'jobEta', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessDate'),
          field: 'jobBusinessDate',
          colId: 'jobBusinessDate',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'jobPono', colId: 'jobPono', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditAmount'), field: 'amountCredit', colId: 'amountCredit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DebitAmount'), field: 'amountDebit', colId: 'amountDebit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditNotWrittenOff'),
          field: 'amountCreditUnverify',
          colId: 'amountCreditUnverify',
          width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DebitNotWrittenOff'),
          field: 'amountDebitUnverify',
          colId: 'amountDebitUnverify',
          width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'), field: 'branchId', colId: 'branchId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'),
          field: 'clearingState',
          colId: 'clearingState',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BillStatus'), field: 'state', colId: 'state', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.getBillState(Number(params.value))
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessedBy'), colId: 'modifiedBy', field: 'modifiedBy',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessingTime'), colId: 'dateModified', field: 'dateModified',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', colId: 'remark', width: 200 }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  methods: {
    bussDateLabFun(params) {
      const bill = params.data
      if (!bill || !bill.charge) { return '' }
      if (bill.charge.length > 0) {
        return ColumnUtils.dateLabelFunc(bill.charge[0].accountingDate)
      }
      return ''
    },
    toQuery() {
    }
  }
}
</script>
<style lang="scss">
</style>
